import * as Yup from 'yup';
import { isNumber } from 'lodash';
import { FinancialSchedulerFormValues } from './FinancialInfoScheduleModal';

const requiredMessage = 'Field is required';

const getFinancialInfoSchedulerSchema = (
  values: FinancialSchedulerFormValues,
) => {
  const schema: any = {};

  if (values?.financialInfoScheduler?.hasOwnProperty('payRate')) {
    schema.payRate = Yup.number()
      .nullable()
      .min(0, 'Pay rate should be from 0 to 999999')
      .max(999999, 'Pay rate should be from 0 to 999999')
      .when('billRate', {
        is: (billRate: number | null) => isNumber(billRate),
        then: Yup.number()
          .nullable()
          .max(Yup.ref('billRate'), 'Pay rate should be less than bill rate'),
      })
      .required(requiredMessage);
  }

  if (values?.financialInfoScheduler?.hasOwnProperty('billRate')) {
    schema.billRate = Yup.number()
      .nullable()
      .min(0, 'Bill rate should be from 0 to 999999')
      .max(999999, 'Bill rate should be from 0 to 999999')
      .required(requiredMessage);
  }

  if (values?.financialInfoScheduler?.hasOwnProperty('profitRate')) {
    schema.profitRate = Yup.number()
      .nullable()
      .min(0, 'Profit rate should be from 0 to 999999')
      .max(999999, 'Profit rate should be from 0 to 999999')
      .required(requiredMessage);
  }

  if (values?.financialInfoScheduler?.hasOwnProperty('dtBillRate')) {
    schema.dtBillRate = Yup.number()
      .nullable()
      .min(0, 'DT Bill rate should be from 0 to 999999')
      .max(999999, 'DT Bill rate should be from 0 to 999999')
      .required(requiredMessage);
  }

  if (values?.financialInfoScheduler?.hasOwnProperty('overtimeBillRate')) {
    schema.overtimeBillRate = Yup.number()
      .nullable()
      .min(0, 'OT bill rate should be from 0 to 999999')
      .max(999999, 'OT bill rate should be from 0 to 999999')
      .required(requiredMessage);
  }

  if (values?.financialInfoScheduler?.hasOwnProperty('overtimePayRate')) {
    schema.overtimePayRate = Yup.number()
      .nullable()
      .min(0, 'OT pay rate should be from 0 to 999999')
      .max(999999, 'OT pay rate should be from 0 to 999999')
      .required(requiredMessage);
  }

  return schema;
};

export const getValidationSchema = (values: FinancialSchedulerFormValues) =>
  Yup.object({
    financialInfoScheduler: Yup.object(getFinancialInfoSchedulerSchema(values)),
    multiRates: multiRatesSchema,
    effectiveDate: Yup.date().nullable().required(requiredMessage),
  });

const payCodeInfoSchema = Yup.object().shape({
  id: Yup.string(),
  payCodeId: Yup.string(),
  payRate: Yup.number()
    .nullable()
    .min(0, 'Pay rate should be from 0 to 999999')
    .max(999999, 'Pay rate should be from 0 to 999999')
    .test('payRate', requiredMessage, function (value) {
      const { payRate } = this.parent;

      return payRate !== undefined && value === null ? false : true;
    }),

  billRate: Yup.number()
    .nullable()
    .min(0, 'Bill rate should be from 0 to 999999')
    .max(999999, 'Bill rate should be from 0 to 999999')
    .test('billRate', requiredMessage, function (value) {
      const { billRate } = this.parent;

      return billRate !== undefined && value === null ? false : true;
    }),
});

const multiRatesSchema = Yup.array().of(
  Yup.object().shape({
    id: Yup.string(),
    payTypeId: Yup.string().nullable(),
    activePayCodeId: Yup.string(),
    payCodesInfo: Yup.array().of(payCodeInfoSchema),
  }),
);
